import LegalShell from "./LegalShell";

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-display text-white text-xl md:text-2xl tracking-tight mb-3">{title}</h2>
    <div className="space-y-3 text-zinc-400">{children}</div>
  </section>
);

const Terms = () => {
  return (
    <LegalShell
      testid="terms-page"
      eyebrow="Legal · Terms"
      title="Terms of Service"
      updated="December 2025"
    >
      <p className="text-zinc-400">
        Welcome to Equal. These Terms of Service (“Terms”) govern your access to and use of
        Equal's website (<span className="text-white">equallayer.app</span>), the EqualLayer product,
        and any related services (collectively, the “Service”). By using the Service you agree to
        be bound by these Terms.
      </p>

      <Section title="1. Who we are">
        <p>
          “Equal”, “we”, “us” or “our” refers to Equal, the company building EqualLayer — an
          accessibility-first interaction layer for the web. If you need to contact us, email{" "}
          <a className="text-indigo-300 hover:text-indigo-200" href="mailto:hello@equallayer.app">
            hello@equallayer.app
          </a>
          .
        </p>
      </Section>

      <Section title="2. Early access">
        <p>
          Equal is currently in private early access. The Service is provided “as is” and “as
          available” without warranties of any kind. Features may change, be limited, or be removed
          as we refine EqualLayer with the accessibility community.
        </p>
      </Section>

      <Section title="3. Your account and use">
        <p>
          You agree to use the Service lawfully, respectfully, and in a way that doesn't harm other
          users, our systems, or third-party websites EqualLayer interacts with. You are responsible
          for any activity that occurs via your email or account.
        </p>
        <p>
          You may not attempt to reverse-engineer, scrape, or interfere with the Service, or use it
          to perform actions you are not authorized to perform on a third-party site.
        </p>
      </Section>

      <Section title="4. Accessibility commitment">
        <p>
          Accessibility is the foundation of Equal, not a feature. We continually work to align with
          WCAG 2.2 AA and welcome feedback from users of assistive technology. If you encounter an
          accessibility barrier in the Service, please email us and we will respond as promptly as
          we can.
        </p>
      </Section>

      <Section title="5. Intellectual property">
        <p>
          All content, branding, and software that make up the Service — including the name
          “Equal”, “EqualLayer”, logos, and the landing page — are owned by Equal or licensed to
          us. You may not copy, modify, or redistribute them without written permission.
        </p>
      </Section>

      <Section title="6. Third-party websites">
        <p>
          EqualLayer is designed to sit on top of third-party websites. We are not affiliated with
          those websites and are not responsible for their content, availability, or terms. Your
          interactions with third-party sites via EqualLayer remain subject to those sites' own
          terms and policies.
        </p>
      </Section>

      <Section title="7. Termination">
        <p>
          We may suspend or terminate your access to the Service at any time if we believe you have
          violated these Terms or if we discontinue the Service. You may stop using the Service at
          any time.
        </p>
      </Section>

      <Section title="8. Liability">
        <p>
          To the maximum extent permitted by law, Equal and its team are not liable for any
          indirect, incidental, special, or consequential damages arising from your use of, or
          inability to use, the Service. Our total liability for any claim will not exceed the
          amount (if any) you paid us in the 12 months preceding the claim.
        </p>
      </Section>

      <Section title="9. Changes to these Terms">
        <p>
          We may update these Terms from time to time. When we do, we'll update the date at the
          top of this page and, for material changes, notify early-access users by email.
        </p>
      </Section>

      <Section title="10. Contact">
        <p>
          Questions about these Terms? Email{" "}
          <a className="text-indigo-300 hover:text-indigo-200" href="mailto:hello@equallayer.app">
            hello@equallayer.app
          </a>
          .
        </p>
      </Section>
    </LegalShell>
  );
};

export default Terms;
